import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <div className="not-found-icon">404</div>
          <h1>Page Not Found</h1>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary btn-lg">
              Go Home
            </Link>
            <Link to="/bill-of-sale" className="btn btn-secondary btn-lg">
              Create Bill of Sale
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
